import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { agentProducerCodeService } from "../../services/agent/agentProducerCodeService";
import { AgentProducerCode } from "../../interfaces/DTO/agent/agentProducerCode";
import { queryKeys } from "../../queries/queryKeys";


/**
 * שליפה של כל קודי סוכן-יצרן לחברה
 */
export const useAgentProducerCodes = () => {
  return useQuery<AgentProducerCode[]>({
    queryKey: queryKeys.agentProducerCodes,
    queryFn: () => agentProducerCodeService.fetchAll(),
    staleTime: 1000 * 60 * 5, // 5 דקות - קאש תקף
    refetchOnWindowFocus: false, // לא מרענן סתם במעבר חלון
  });
};

/**
 * יצירה של קוד חדש
 */
export const useCreateAgentProducerCode = () => {
    const queryClient = useQueryClient();

    return useMutation({
      mutationFn: (newItem: AgentProducerCode) => agentProducerCodeService.create(newItem),
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: queryKeys.agentProducerCodes });
      },
    });
  };
/**
 * עדכון חלקי של קוד קיים
 */
export const useUpdateAgentProducerCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (updateData: { id: number; data: Partial<AgentProducerCode> }) =>
      agentProducerCodeService.partialUpdate(updateData.id, updateData.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.agentProducerCodes });
    },
  });
};

/**
 * מחיקה של קוד
 */
export const useDeleteAgentProducerCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: { id: number }) =>
      agentProducerCodeService.delete(params.id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.agentProducerCodes });
    },
  });
};
